/* eslint-disable no-undef */
export default class InteractiveMap {
	init() {
		if ($('#map')[0]) {
			ymaps.ready(() => {
				const point = [56.086441, 37.616392];
				const imgPath = 'images/pin@2x.png';

				const myMap = new ymaps.Map('map', {
					center: point,
					zoom: 16,
					controls: ['fullscreenControl']
				});

				const marker = new ymaps.Placemark(point, {}, {
					iconLayout: 'default#image',
					iconImageHref: imgPath,
					iconImageSize: [52, 67],
					iconImageOffset: [-26, -67]
				});

				myMap.geoObjects.add(marker);
				myMap.behaviors.disable('scrollZoom');
				myMap.behaviors.disable('drag');
			});
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/interactive-map/index.js